import { formatDate } from "@/lib/formatters";
import { AdjustmentProperty } from "@/types/serializers";
import { parseISO } from "date-fns";

export function PropertyHeader({ adjustment }: { adjustment: AdjustmentProperty }) {
  const effectiveDate = adjustment.effective_date ? parseISO(adjustment.effective_date) : undefined;
  return (
    <div className="text-sm font-normal">
      <div>
        Property Address: <span className="font-bold">{adjustment.address}</span>
      </div>
      <div>
        Effective Date:{" "}
        <span className="font-bold">
          {effectiveDate ? formatDate(effectiveDate.getTime()) : ""}
        </span>
      </div>
      {adjustment.prepared_by && (
        <div>
          Prepared By: <span className="font-bold">{adjustment.prepared_by}</span>
        </div>
      )}
    </div>
  );
}
